import React, { Component } from 'react';
import { Link } from "react-router-dom";
class Footer extends Component {
    render() {
        const localStor = localStorage.getItem('theme');
        return (
            <React.Fragment>
                <div className="footer mt-5 p-3">
                    <div className="container text-center text-white-50">
                        <div className="py-3">
                            <Link to="/">
                                <img src={process.env.PUBLIC_URL + `${localStor === 'dark' ? "/logo.png" : "/logodark.png"}`} alt="Logo" style={{ maxWidth: '200px' }} />
                            </Link>
                        </div>
                        <ul className="list-inline h2">
                            <li className="list-inline-item"><Link to="#"><i className="bi bi-facebook"></i></Link></li>
                            <li className="list-inline-item"><Link to="#"><i className="bi bi-youtube"></i></Link></li>
                            <li className="list-inline-item"><Link to="#"><i className="bi bi-telegram"></i></Link></li>
                        </ul>
                        <p>This website was created by Front-end Developer DS Sombol for learning purposes only.</p>
                        <div className="navbar-collapse">
                            <ul className="list-inline">
                                <li className="list-inline-item"><Link to="/">Home</Link></li>
                                <li className="list-inline-item"><Link to="#">API</Link></li>
                                <li className="list-inline-item"><Link to="#">Contact</Link></li>
                                <li className="list-inline-item"><Link to="#">How to USE</Link></li>
                            </ul>
                        </div>
                    </div>
                    <div className="text-center text-white-50">
                        <h6>Power by DS Sombol, All right reserved</h6>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Footer;